import _ from 'lodash'
import $ from 'jquery'

export var storage = window.localStorage

export function get(item) {
  return JSON.parse(storage.getItem(item))
}
export function getPath(item, path) {
  return _.get(get(item), path)
}

export function set(item, value) {
  let storageValue = get(item) || {}
  let newStorageValue = _.merge({}, storageValue, value)
  return storage.setItem(item, JSON.stringify(newStorageValue))
}

export function setPath(item, path, value) {
  let storageValue = get(item) || {}
  let newStorageValue = _.set({}, path, value)
  return set(item, newStorageValue)
}


var storageObject = {get, getPath, set, setPath, storage}
export default storageObject
